module.exports = __webpack_public_path__ + "img/HeroTypesQuiz_Trailblazer.5f6ddaaa.png";